import { Modal } from 'antd'

import { CompletePageConditionalRuleModel } from '@/domain/model/forms'
import { useUpdateURLSearchParams } from '@/hooks/useQuery'
import useSearchParams from '@/hooks/useSearchParams'
import { transformFromResponseToCompleteConditionalRuleForm } from '@/utils/conditionalCompletePage/transformFromResponseToCompleteConditionalRuleForm'

import {
  ConditionCompletePageForm,
  ConditionCompletePageFormProps,
} from './ConditionCompletePageForm'
import { FormAddConditionCompletePageModel } from './useAddConditionCompletePageForm'

type Props = {
  initialValues?: CompletePageConditionalRuleModel[]
} & Omit<ConditionCompletePageFormProps, 'initialValues'>

export const EditConditionCompletePageModal = ({
  onFinish,
  initialValues,
}: Props) => {
  const searchParams = useSearchParams()
  const updateParams = useUpdateURLSearchParams()

  const editConditionSettingsId = searchParams.get('edit_condition_settings')

  const transformConditionSettings =
    transformFromResponseToCompleteConditionalRuleForm(initialValues)

  const findConditionById = transformConditionSettings?.find(
    (item) => item.id === editConditionSettingsId
  ) as FormAddConditionCompletePageModel

  const handleClose = () => {
    updateParams(
      ['condition_settings', undefined],
      ['edit_condition_settings', undefined],
      ['form_id', undefined]
    )
  }

  return (
    <Modal
      centered
      open
      footer={() => undefined}
      maskClosable={false}
      onCancel={handleClose}
      onClose={handleClose}
      title="Edit Condition"
      width={{
        xs: '90%',
        sm: '80%',
        md: '90%',
        lg: '90%',
        xl: '75%',
        xxl: '60%',
      }}
    >
      <ConditionCompletePageForm
        {...{ onFinish, initialValues: findConditionById }}
      />
    </Modal>
  )
}
